import src from "IMAGE";
export default { src, width: 826, height: 164, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAMUlEQVR42i3FsQkAIAxFwb+UA1iKqAgqotl/jrwixXGStLAxkHHR0VCghx8nGCYOqgOebgUIeMFv2QAAAABJRU5ErkJggg=="};
